export const contentTableConfig = {
  title: '三方电话资源账号配置',
  propList: [
    { prop: 'corpName', label: '主体', minWidth: '120' },
    { prop: 'workAccount', label: '工作账号', minWidth: '120' },
    { prop: 'startDate', label: '承接资源开始日期', minWidth: '140' },
    { prop: 'endDate', label: '承接资源结束日期', minWidth: '140' },
    { prop: 'statusDesc', label: '状态', minWidth: '100' },
    { prop: 'createdTime', label: '创建时间', minWidth: '160' },
    { prop: 'createdBy', label: '创建人', minWidth: '100' },
    { label: '操作', minWidth: '150', slotName: 'handler', fixed: 'right' }
  ],
  showIndexColumn: true,
  showSelectColumn: false
}
